export default "__VITE_ASSET__fa4d813c__"